var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useRef, useEffect, useState, useCallback } from 'react';
import styled from 'styled-components';
import { scrollTo } from '../../utils/util';
var ShortSpec = function (_a) {
    var spec = _a.spec;
    var _b = useState(1), textLine = _b[0], setTextLine = _b[1];
    var div = useRef(null);
    var moveSpec = useCallback(function () {
        var fixHeight = 128;
        scrollTo(".tab_contents_target2", -fixHeight + 2, 'auto');
    }, []);
    useEffect(function () {
        var _a;
        if (((_a = div.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) >= 40) {
            setTextLine(2);
        }
    }, [spec]);
    // split 대비 형변환
    if (spec !== null)
        spec = spec.toString();
    return (React.createElement(Style, { ref: div }, (spec !== null && spec.length !== 0) && (React.createElement(React.Fragment, null,
        spec.split('|').map(function (v, i) { return (React.createElement(React.Fragment, { key: i },
            React.createElement("span", null, v),
            ' ',
            spec.split('|').length - 1 !== i && React.createElement(React.Fragment, null,
                "\u3163",
                ' '))); }),
        spec.length > 0 && (React.createElement(Button, { type: "button", textLine: textLine, onClick: moveSpec }, "+\uB354\uBCF4\uAE30"))))));
};
var Style = styled.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    // max-width: 690px;\n    // max-width: 850px;\n    // XD\uC218\uCE58 \uCC38\uACE0\n    // https://xd.adobe.com/view/a9f78301-8233-42b5-a280-9c7bc5da0b53-fca4/screen/0ac234c2-b0ea-4013-8e96-5e1764a69218/specs/\n    // max-width: 644px;\n    max-width: 797px;\n    padding: 0 50px 0 0;\n    margin: 0 0 8px;\n    font-size: 12px;\n    color: #999;\n    line-height: 20px;\n    display: -webkit-box;\n    // -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    span {\n        /* display: inline-block; */\n    }\n"], ["\n    position: relative;\n    // max-width: 690px;\n    // max-width: 850px;\n    // XD\uC218\uCE58 \uCC38\uACE0\n    // https://xd.adobe.com/view/a9f78301-8233-42b5-a280-9c7bc5da0b53-fca4/screen/0ac234c2-b0ea-4013-8e96-5e1764a69218/specs/\n    // max-width: 644px;\n    max-width: 797px;\n    padding: 0 50px 0 0;\n    margin: 0 0 8px;\n    font-size: 12px;\n    color: #999;\n    line-height: 20px;\n    display: -webkit-box;\n    // -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    span {\n        /* display: inline-block; */\n    }\n"])));
var Button = styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: absolute;\n    right: -5px;\n    bottom: ", "px;\n    border: 0;\n    padding: 5px;\n    background: none;\n    font-size: 12px;\n    color: #707070;\n\n    &:hover {\n        color: #418ded;\n    }\n"], ["\n    position: absolute;\n    right: -5px;\n    bottom: ", "px;\n    border: 0;\n    padding: 5px;\n    background: none;\n    font-size: 12px;\n    color: #707070;\n\n    &:hover {\n        color: #418ded;\n    }\n"])), function (_a) {
    var textLine = _a.textLine;
    return textLine === 1 ? '14' : '-3';
});
export default ShortSpec;
var templateObject_1, templateObject_2;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/product_head/short_spec.tsx
// module id = 180
// module chunks = 0